export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.80bfdf19eacc90ec335f7eecf1a15b94.css";